import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sadeteenshaktipeeth() {


const cardData = {
keyword: "Sadeteenshaktipeeth tour from pune by bus",
headingDescription: "Ruturaj Enterprises provides Sadeteenshaktipeeth tour from Pune by bus for devotees, families, religious groups, senior citizens, friends, and organized pilgrimage parties. Comfortable AC, luxury, and suitable-capacity buses can be arranged for a planned Sade Teen Shaktipeeth Yatra covering important temples such as Kolhapur, Tuljapur, Mahur, and Saptashrungi. The journey can be organized as a multi-day pilgrimage with convenient Pune pickup points, temple Darshan schedules, rest breaks, sightseeing stops, accommodation coordination requirements, and return travel planned around the group's itinerary.",
topPlaces: [
{
title: "Mahalaxmi Temple, Kolhapur",
description: "Mahalaxmi Temple in Kolhapur is one of the most revered Shakti worship destinations in Maharashtra and an important stop on a Sade Teen Shaktipeeth pilgrimage. Devotees traveling from Pune can include the temple as part of an organized multi-day Yatra with dedicated group transportation."
},
{
title: "Tulja Bhavani Temple, Tuljapur",
description: "Tulja Bhavani Temple in Tuljapur is a major pilgrimage destination dedicated to Goddess Bhavani and attracts devotees from different parts of Maharashtra. A dedicated bus makes it convenient for families and religious groups to travel together for Darshan and continue their planned Shakti Yatra."
},
{
title: "Renuka Devi Temple, Mahur",
description: "Renuka Devi Temple at Mahur is an important spiritual destination situated in the scenic Nanded region. Groups undertaking a Shakti pilgrimage can include Mahur in their itinerary while using dedicated transportation for the longer journey between different temple destinations."
},
{
title: "Saptashrungi Devi Temple",
description: "Saptashrungi Devi Temple at Vani is a prominent hilltop shrine associated with Goddess Saptashrungi and is an important pilgrimage destination in Maharashtra. Devotees can plan the temple visit as part of a comprehensive Shaktipeeth tour from Pune."
},
{
title: "Jyotiba Temple, Kolhapur",
description: "Jyotiba Temple is located on a hill near Kolhapur and is visited by devotees throughout the year. Groups traveling for a Shakti pilgrimage can combine the temple with Mahalaxmi Darshan and other Kolhapur attractions in a single organized itinerary."
},
{
title: "Aundha Nagnath Temple",
description: "Aundha Nagnath is a significant religious destination in Maharashtra and is associated with one of the revered Jyotirlinga traditions. Pilgrimage groups can add the temple to an extended spiritual tour when their itinerary includes the Marathwada region."
},
{
title: "Nashik",
description: "Nashik is an important religious and cultural city with several temples and pilgrimage attractions along the Godavari River. Groups traveling toward Saptashrungi can include Nashik sightseeing or spiritual stops depending on their route and available travel time."
},
{
title: "Trimbakeshwar Temple",
description: "Trimbakeshwar Temple near Nashik is a major pilgrimage destination and one of the revered Jyotirlinga temples. Devotees planning a broader Maharashtra religious tour can combine Trimbakeshwar with Shaktipeeth destinations using dedicated group transportation."
},
{
title: "Pandharpur",
description: "Pandharpur is one of Maharashtra's most important pilgrimage cities and is associated with Lord Vitthal and Rukmini. Religious groups can consider adding Pandharpur to an extended pilgrimage itinerary when planning a longer multi-destination tour from Pune."
},
{
title: "Alandi",
description: "Alandi is a prominent spiritual destination associated with Sant Dnyaneshwar Maharaj and attracts devotees throughout the year. It can be included as an additional spiritual stop before or after the main Sade Teen Shaktipeeth itinerary depending on the group's travel plan."
}
],
services: [
{
name: "Sade Teen Shaktipeeth Tour Bus Pune",
description: "Sade Teen Shaktipeeth Tour Bus Pune provides dedicated transportation for devotees, families, religious organizations, and organized pilgrimage groups. The journey can be structured around the major Shaktipeeth destinations, temple Darshan timings, rest breaks, sightseeing requirements, and a planned return to Pune."
},
{
name: "Sade Teen Shaktipeeth Bus Package Pune",
description: "Sade Teen Shaktipeeth Bus Package Pune is suitable for groups planning a multi-day pilgrimage covering important Shakti worship destinations across Maharashtra. Vehicle capacity, travel schedule, route sequence, temple visits, breaks, and group requirements can be considered while organizing the package."
},
{
name: "Sade Teen Shaktipeeth Tour from Pune",
description: "Sade Teen Shaktipeeth Tour from Pune offers an organized group travel solution for devotees beginning their pilgrimage in Pune. The itinerary can include Mahalaxmi Temple, Tulja Bhavani Temple, Renuka Devi Temple, Saptashrungi, and additional spiritual destinations selected by the group."
},
{
name: "Shaktipeeth Yatra Bus from Pune",
description: "Shaktipeeth Yatra Bus from Pune is designed for devotees and religious groups traveling together across multiple temple destinations. A dedicated bus simplifies coordination during the long-distance journey and provides common transportation throughout the pilgrimage program."
},
{
name: "Sade Teen Shaktipeeth Bus Booking Pune",
description: "Sade Teen Shaktipeeth Bus Booking Pune allows groups to arrange transportation according to their planned pilgrimage dates and passenger count. Pickup points, bus capacity, AC requirements, route sequence, temple schedules, luggage needs, and return plans can be considered during the booking process."
},
{
name: "Shaktipeeth Bus Rental Pune",
description: "Shaktipeeth Bus Rental Pune provides a practical group transportation option for families, devotees, community groups, and tour organizers. The bus can support multi-day religious travel while accommodating the group's preferred route, sightseeing stops, rest breaks, and travel schedule."
},
{
name: "Shaktipeeth Tour Bus Hire Pune",
description: "Shaktipeeth Tour Bus Hire Pune is suitable for organized pilgrimage parties that want to travel together between several temples. A dedicated bus helps maintain a common itinerary and simplifies transportation during the onward journey, local movement, and return trip."
},
{
name: "Shaktipeeth Pilgrimage Bus Pune",
description: "Shaktipeeth Pilgrimage Bus Pune provides group transportation for devotees visiting revered temples across Maharashtra. Families, senior citizens, religious organizations, and community groups can plan the journey around Darshan timings, meal breaks, overnight halts, and selected sightseeing destinations."
},
{
name: "Sade Teen Shaktipeeth AC Bus Pune",
description: "Sade Teen Shaktipeeth AC Bus Pune offers a comfortable transportation option for groups undertaking a longer pilgrimage. Air-conditioned travel can be particularly useful when the itinerary involves extended road journeys between temples and multiple days of group travel."
},
{
name: "Luxury Bus for Shaktipeeth Yatra Pune",
description: "Luxury Bus for Shaktipeeth Yatra Pune is suitable for devotees and organized groups seeking enhanced comfort during a multi-day pilgrimage. Families, corporate-sponsored religious groups, and premium tour parties can choose a suitable luxury-oriented vehicle according to their travel requirements."
},
{
name: "Shaktipeeth Group Tour Bus Pune",
description: "Shaktipeeth Group Tour Bus Pune is ideal for friends, relatives, religious associations, community groups, and organized pilgrimage parties. Common transportation allows the complete group to follow the same route and coordinate temple visits, meal breaks, sightseeing, and overnight travel."
},
{
name: "Shaktipeeth Family Tour Bus Pune",
description: "Shaktipeeth Family Tour Bus Pune provides convenient transportation for families undertaking a spiritual journey across Maharashtra. A dedicated bus helps family members travel together while allowing the itinerary to include temple Darshan, rest stops, sightseeing, and suitable travel breaks."
},
{
name: "Shaktipeeth Darshan Bus Package Pune",
description: "Shaktipeeth Darshan Bus Package Pune supports organized temple visits across the major Shaktipeeth pilgrimage destinations. The group can plan a structured route with dedicated transportation, allowing devotees to focus on Darshan while the travel schedule is coordinated around the pilgrimage itinerary."
},
{
name: "Shaktipeeth Yatra Bus Package Pune",
description: "Shaktipeeth Yatra Bus Package Pune is suitable for groups looking for a dedicated vehicle for a complete religious tour. The package itinerary can be planned around the number of temples, duration of travel, passenger capacity, sightseeing preferences, overnight halts, and return journey."
},
{
name: "Affordable Shaktipeeth Bus Tour Pune",
description: "Affordable Shaktipeeth Bus Tour Pune provides a practical option for devotees and groups seeking to manage transportation costs during a multi-destination pilgrimage. Selecting an appropriately sized bus and planning an efficient route can help reduce unnecessary travel expenses."
},
{
name: "Sade Teen Shaktipeeth Group Transportation",
description: "Sade Teen Shaktipeeth Group Transportation provides centralized travel arrangements for large families, religious organizations, community groups, and tour parties. A common vehicle makes it easier to coordinate passengers, luggage, temple visits, meal breaks, and movement between different pilgrimage destinations."
},
{
name: "Shaktipeeth Temple Tour Bus Pune",
description: "Shaktipeeth Temple Tour Bus Pune provides dedicated transportation for devotees visiting important Goddess temples across Maharashtra. The itinerary can be arranged around temple timings and can include additional religious landmarks or sightseeing locations where suitable."
},
{
name: "Shaktipeeth Religious Tour Bus Pune",
description: "Shaktipeeth Religious Tour Bus Pune is designed for spiritual and devotional group journeys covering multiple temple destinations. Families, devotees, religious organizations, and community groups can travel together while following a structured multi-day pilgrimage schedule."
},
{
name: "Pune Shaktipeeth Outstation Bus Hire",
description: "Pune Shaktipeeth Outstation Bus Hire is suitable for groups traveling beyond Pune for an extended religious tour. The bus can be selected according to passenger strength, luggage requirements, journey duration, route distance, sightseeing plans, and the number of temple visits."
},
{
name: "Shaktipeeth Tour Package by AC Bus Pune",
description: "Shaktipeeth Tour Package by AC Bus Pune provides a comfortable group travel option for devotees undertaking a longer pilgrimage. Air-conditioned transportation can support multi-day journeys while the itinerary is organized around temple Darshan, rest periods, sightseeing, and return travel."
},
{
name: "Sade Teen Shaktipeeth Travel Bus Pune",
description: "Sade Teen Shaktipeeth Travel Bus Pune offers dedicated transportation for groups following a spiritual itinerary across Maharashtra. The vehicle can remain part of the complete tour plan, making movement between temple destinations easier for families, devotees, and organized pilgrimage parties."
},
{
name: "Shaktipeeth Darshan Bus Booking Service",
description: "Shaktipeeth Darshan Bus Booking Service helps pilgrimage groups arrange suitable transportation for their planned temple visits. Travel date, passenger count, pickup location, vehicle capacity, AC preference, route sequence, Darshan schedule, and return requirements can be considered during trip planning."
}
],
tableData: [
["Sade Teen Shaktipeeth Tour Bus Pune", "Sade Teen Shaktipeeth Bus Package Pune"],
["Sade Teen Shaktipeeth Tour from Pune", "Shaktipeeth Yatra Bus from Pune"],
["Sade Teen Shaktipeeth Bus Booking Pune", "Shaktipeeth Bus Rental Pune"],
["Shaktipeeth Tour Bus Hire Pune", "Shaktipeeth Pilgrimage Bus Pune"],
["Sade Teen Shaktipeeth AC Bus Pune", "Luxury Bus for Shaktipeeth Yatra Pune"],
["Shaktipeeth Group Tour Bus Pune", "Shaktipeeth Family Tour Bus Pune"],
["Shaktipeeth Darshan Bus Package Pune", "Shaktipeeth Yatra Bus Package Pune"],
["Affordable Shaktipeeth Bus Tour Pune", "Sade Teen Shaktipeeth Group Transportation"],
["Shaktipeeth Temple Tour Bus Pune", "Shaktipeeth Religious Tour Bus Pune"],
["Pune Shaktipeeth Outstation Bus Hire", "Shaktipeeth Tour Package by AC Bus Pune"],
["Sade Teen Shaktipeeth Travel Bus Pune", "Shaktipeeth Darshan Bus Booking Service"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Multi-Temple Transportation",
WhyChoosedescription: "A dedicated bus keeps devotees together while traveling between several pilgrimage destinations across Maharashtra. This makes passenger coordination, luggage management, temple visits, meal breaks, and onward travel easier to organize during the complete Yatra."
},
{
WhyChooseheading: "Suitable for Multi-Day Pilgrimages",
WhyChoosedescription: "Sade Teen Shaktipeeth travel generally involves more than one destination, making planned transportation particularly useful. Groups can structure the journey around temple Darshan, overnight halts, rest periods, sightseeing, and the return journey to Pune."
},
{
WhyChooseheading: "Comfort for Devotees of All Ages",
WhyChoosedescription: "Pilgrimage groups often include children, adults, and senior citizens traveling together. Comfortable bus options provide a shared travel environment and make longer road journeys between different religious destinations more manageable for the entire group."
},
{
WhyChooseheading: "AC and Luxury Bus Options",
WhyChoosedescription: "Groups looking for additional comfort can consider AC or luxury-oriented transportation for the pilgrimage. These options are useful for families, organized religious groups, and travelers undertaking an extended multi-day temple tour."
},
{
WhyChooseheading: "Flexible Temple Tour Planning",
WhyChoosedescription: "A pilgrimage itinerary can include the major Shakti destinations along with additional temples, heritage sites, or sightseeing attractions. Dedicated transportation provides the flexibility to organize the route according to the group's preferred sequence and available travel time."
},
{
WhyChooseheading: "Practical for Religious Organizations",
WhyChoosedescription: "Religious associations, community groups, and devotional organizations can benefit from centralized transportation for their Yatra programs. One common vehicle simplifies group movement and helps maintain a coordinated schedule across multiple destinations."
},
{
WhyChooseheading: "Convenient Group Travel from Pune",
WhyChoosedescription: "Starting the pilgrimage with a dedicated bus from Pune eliminates the need for multiple private vehicles and separate route planning. The group can depart from a convenient pickup location and continue together throughout the planned Shaktipeeth tour."
},
{
WhyChooseheading: "Organized Round-Trip Journey",
WhyChoosedescription: "Planning onward and return transportation as part of the same pilgrimage arrangement helps simplify the overall journey. The bus can support travel between temples, sightseeing stops, rest locations, and the eventual return to Pune according to the planned itinerary."
}
]
};














const faqData = [
{
question: "Can I book a bus for a Sadeteenshaktipeeth tour from Pune?",
answer: "A private bus is a convenient choice for groups planning a Sadeteenshaktipeeth pilgrimage from Pune. Ruturaj Enterprises can arrange suitable group transportation based on the number of passengers, luggage, travel duration, preferred itinerary, and required sightseeing stops."
},
{
question: "What does a Sadeteenshaktipeeth tour from Pune include?",
answer: "A Sadeteenshaktipeeth tour generally focuses on visiting the revered Shaktipeeth temples included in the pilgrimage itinerary. Depending on the selected route and duration, the trip can be planned with temple visits, rest breaks, overnight halts, meals, and return transportation from Pune."
},
{
question: "Is a bus suitable for a Sadeteenshaktipeeth pilgrimage with family?",
answer: "Families traveling with several relatives can benefit from a dedicated bus for this type of pilgrimage. Everyone remains together during the journey, making it easier to coordinate temple visits, luggage, meal breaks, rest stops, and departure timings across the different destinations."
},
{
question: "Can senior citizens travel on a Sadeteenshaktipeeth tour by bus?",
answer: "A dedicated bus can make a long pilgrimage more manageable for groups that include senior citizens. The travel schedule can incorporate suitable rest stops and a comfortable pace, while the vehicle selection can be based on passenger numbers, luggage, journey duration, and group requirements."
},
{
question: "How many days are required for a Sadeteenshaktipeeth tour from Pune?",
answer: "The required duration depends on the temples included, route selected, sightseeing preferences, overnight halts, and time available for darshan. A multi-day itinerary is generally more suitable when the group wants to cover several pilgrimage destinations without making the schedule unnecessarily rushed."
},
{
question: "Can we hire an AC bus for a Sadeteenshaktipeeth tour from Pune?",
answer: "Groups seeking additional comfort during a long pilgrimage journey can consider an AC bus. Ruturaj Enterprises can help identify an appropriate vehicle according to group size, travel distance, luggage requirements, trip duration, and the overall itinerary planned for the pilgrimage."
},
{
question: "Can a large religious group rent a bus for the Sadeteenshaktipeeth tour?",
answer: "Religious organizations, community groups, families, and groups of devotees can arrange dedicated bus transportation for the pilgrimage. Traveling together simplifies group coordination and provides a common vehicle for moving between temples and planned overnight or rest locations."
},
{
question: "Can the bus stay with the group throughout the complete pilgrimage?",
answer: "A dedicated tour arrangement can be planned around the group's complete itinerary, allowing transportation to remain coordinated throughout the pilgrimage. This is particularly useful for multi-day journeys where the group needs transportation between several temple destinations and the final return to Pune."
},
{
question: "What bus seating capacity is available for Sadeteenshaktipeeth tours?",
answer: "Bus capacity should be selected according to the total number of devotees traveling together, along with their luggage and comfort requirements. Ruturaj Enterprises can help determine a suitable vehicle for smaller family groups as well as larger pilgrimage parties."
},
{
question: "Why choose Ruturaj Enterprises for a Sadeteenshaktipeeth tour from Pune by bus?",
answer: "Ruturaj Enterprises provides group transportation for pilgrimage and multi-destination tours from Pune. The bus rental can be planned around the number of travelers, temple itinerary, overnight halts, luggage, travel duration, and sightseeing requirements, helping the group manage the complete pilgrimage journey in an organized manner."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Mahesh Deshpande",
feedback:
"Our family group planned a Sadeteenshaktipeeth pilgrimage from Pune and chose Ruturaj Enterprises for the bus arrangement. Having everyone travel together made the long journey much easier to coordinate, especially during temple visits and rest stops. The overall trip was organized and convenient.",
rating: 5
},
{
id: 2,
name: "Miss. Kavita Joshi",
feedback:
"We traveled with a group of devotees for a Sadeteenshaktipeeth tour from Pune. Ruturaj Enterprises arranged a suitable bus for our group, giving us a common vehicle throughout the pilgrimage. Managing the temple itinerary, luggage, and travel between destinations became much simpler for everyone.",
rating: 5
}
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sadeteenshaktipeeth tour from pune by bus",
  "image": "https://ruturajenterprises.com/assets/images/sadeteenshaktipeeth-tour-from-pune-by-bus.webp",
  "description":
    "Sadeteenshaktipeeth tour from pune by bus for devotees, families, and groups planning a comfortable pilgrimage journey across the important Shaktipeeth temples of Maharashtra. Ruturaj Enterprises offers suitable bus rental options from Pune with experienced drivers, convenient travel arrangements, flexible tour schedules, and comfortable seating for multi-day religious tours covering the Sade Teen Shaktipeeth circuit and nearby spiritual destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/sadeteenshaktipeeth-tour-from-pune-by-bus"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Sadeteenshaktipeeth tour from pune by bus | Sade Teen Shaktipeeth Tour Bus Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Sadeteenshaktipeeth tour from pune by bus for devotees, families and groups. Plan a comfortable Sade Teen Shaktipeeth pilgrimage from Pune with suitable buses, experienced drivers and flexible multi-day tour arrangements."
  />

  <meta
    name="keywords"
    content="Sade Teen Shaktipeeth Tour Bus Pune, Sade Teen Shaktipeeth Bus Package Pune, Sade Teen Shaktipeeth Tour from Pune, Shaktipeeth Yatra Bus Pune, Sade Teen Shaktipeeth Yatra Bus Pune, Sade Teen Shaktipeeth Yatra Package Pune, Sade Teen Shaktipeeth Darshan Bus Pune, Sade Teen Shaktipeeth Darshan Package Pune, Sade Teen Shaktipeeth Tour Package Pune, Sade Teen Shaktipeeth Bus Rental Pune, Sade Teen Shaktipeeth Bus Hire Pune, Sade Teen Shaktipeeth Bus Booking Pune, Shaktipeeth Tour Package from Pune by Bus, Shaktipeeth Yatra from Pune by Bus, Shaktipeeth Darshan Bus from Pune, Pune Shaktipeeth Tour Bus, Pune Shaktipeeth Yatra Bus, Pune Shaktipeeth Pilgrimage Bus, Pune Shaktipeeth Religious Tour Bus, Pune Sade Teen Shaktipeeth Group Tour, Pune Sade Teen Shaktipeeth Family Tour, Sade Teen Shaktipeeth Group Bus Pune, Sade Teen Shaktipeeth Family Bus Pune, Sade Teen Shaktipeeth AC Bus Pune, Luxury Bus for Shaktipeeth Tour Pune, AC Bus Rental for Shaktipeeth Yatra Pune, Shaktipeeth Tourist Bus Pune, Shaktipeeth Pilgrimage Bus Rental Pune, Shaktipeeth Pilgrimage Bus Hire Pune, Shaktipeeth Yatra Bus Rental Pune, Shaktipeeth Yatra Bus Hire Pune, Shaktipeeth Temple Tour Bus Pune, Sade Teen Shaktipeeth Temple Tour Pune, Sade Teen Shaktipeeth One Week Tour Pune, Sade Teen Shaktipeeth Multi Day Tour Pune, Sade Teen Shaktipeeth One Day Trip Pune, Sade Teen Shaktipeeth Family Trip Pune, Sade Teen Shaktipeeth Group Travel Pune, Sade Teen Shaktipeeth Religious Trip Pune, Sade Teen Shaktipeeth Bus Tour Package from Pune, Sade Teen Shaktipeeth Tourist Bus Rental Pune, Sade Teen Shaktipeeth Outstation Bus Pune, Pune Shaktipeeth Tour Package by Bus, Pune Shaktipeeth Bus Tour Package, Pune Shaktipeeth Bus Rental Service, Pune Shaktipeeth Bus Hire Service, Pune Shaktipeeth Bus Booking Service, 20 Seater Bus for Shaktipeeth Tour Pune, 32 Seater Bus for Shaktipeeth Tour Pune, 35 Seater Bus for Shaktipeeth Tour Pune, 45 Seater Bus for Shaktipeeth Tour Pune, 50 Seater Bus for Shaktipeeth Tour Pune, Affordable Shaktipeeth Tour Bus Pune, Comfortable Shaktipeeth Yatra Bus Pune, Ruturaj Enterprises Shaktipeeth Tour Bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sadeteenshaktipeeth ;